module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/hyper-v.35a24838.png";